import { Component } from '@verndale/core';
import clamp from 'clamp-js-main';
import { tns } from 'tiny-slider/src/tiny-slider';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      titles: this.el.querySelectorAll('.news-card__title'),
      slider: this.el.querySelector('.recent-news__listing'),
      sliderButtons: this.el.querySelector('.recent-news__slider-buttons')
    };

    this.clampText();
    this.initSlider();
  }

  clampText() {
    this.dom.titles.forEach(teaser => {
      clamp(teaser, { clamp: 5 });
    });
  }

  initSlider() {
    tns({
      container: this.dom.slider,
      controlsContainer: this.dom.sliderButtons,
      items: 1,
      gutter: 20,
      slideBy: 'page',
      loop: false,
      nav: false,
      preventScrollOnTouch: 'auto',
      responsive: {
        768: {
          items: 2
        },
        1024: {
          items: 3
        },
        1440: {
          gutter: 44
        },
        1600: {
          items: 4
        }
      }
    });
  }
}

export default Module;
